export default __webpack_public_path__ + "static/app-store-download-3bc8a317cb15e8edf40759be9cf7786e.jpeg";